import { BaseQueryFn, createApi } from "@reduxjs/toolkit/query/react";
import { demoRequest, ensureDemoData } from "../../utils/demo";

ensureDemoData();

const demoBaseQuery: BaseQueryFn<any, unknown, { status: string; data: string }> =
  async (args) => {
    try {
      const request = typeof args === "string" ? { url: args } : args;
      const response = await demoRequest({
        url: request.url,
        method: request.method,
        data: request.body ?? request.data,
        headers: request.headers,
      });

      return { data: response.data };
    } catch (error: any) {
      return {
        error: {
          status: "CUSTOM_ERROR",
          data: error?.message || "Demo request failed",
        },
      };
    }
  };

export const Api = createApi({
  reducerPath: "public",
  baseQuery: demoBaseQuery,
  tagTypes: ["StoreInfo", "explore", "SingleItem", "Orders", 'SingleTable'],
  endpoints: (builder) => ({
    getStoreInfo: builder.query<any, any>({
      query: ({ identify }) => `/store/${identify}`,
      providesTags: ["StoreInfo"],
    }),
    getStoreProducts: builder.query<any, any>({
      query: ({ identify, filterCategory }) =>
        `/product/${identify}/list${filterCategory ? `${"?categoryId=" + filterCategory?._id}` : ""
        }`,
      providesTags: ["explore"],
    }),
    getStoreCategory: builder.query<any, any>({
      query: ({ identify }) => `/categories/${identify}`,
      providesTags: ["explore"],
    }),
    getSingleItem: builder.query<any, any>({
      query: ({ ItemId }) => `/product/${ItemId}`,
      providesTags: ["SingleItem"],
    }),
    getTables: builder.query<any, any>({
      query: ({ identify }) => `/table/all/${identify}`,
      providesTags: ["SingleTable"],
    }),
  }),
});
export const ProtectAPIs = createApi({
  reducerPath: "ProtectAPIs",
  baseQuery: demoBaseQuery,
  tagTypes: ["StoreList", "Orders"],
  endpoints: (builder) => ({
    getStoreList: builder.query({
      query: () => `/admin/stores`,
      providesTags: ["StoreList"],
    }),
    getStoreOrders: builder.query<any, any>({
      query: ({ storeId, filterOrders }) =>
        `/order/${storeId}${filterOrders ? `${"?takeawayType=" + filterOrders?.takeawayType}` : ""
        }`,
      providesTags: ["Orders"],
    }),
  }),
});
export const {
  useGetSingleItemQuery,
  useGetStoreInfoQuery,
  useGetStoreProductsQuery,
  useGetStoreCategoryQuery,
  useGetTablesQuery,
} = Api;
export const { useGetStoreListQuery, useGetStoreOrdersQuery } = ProtectAPIs;
